import { useState, useRef } from 'react';
import { validarPdf, fmtTamanho, MAX_PDF_MB } from '../../utils/especificacao';

/**
 * Área pra enviar o PDF que o arquiteto já fez no programa dele: arrasta e solta
 * (computador) ou toca pra escolher (celular). Valida tipo e tamanho na hora e
 * mostra o progresso do envio. Quem envia de fato é o pai (`onEscolher`).
 */
export default function EnvioPdf({ arquivo, onEscolher, progresso = null, desabilitado = false }) {
  const [arrastando, setArrastando] = useState(false);
  const [erro, setErro] = useState('');
  const input = useRef(null);

  const pegar = (file) => {
    const e = validarPdf(file);
    setErro(e || '');
    if (!e) onEscolher(file);
  };

  return (
    <div>
      <button
        type="button"
        className={`esp-envio ${arrastando ? 'arrastando' : ''} ${arquivo ? 'tem' : ''}`}
        onClick={() => !desabilitado && input.current?.click()}
        onDragOver={e => { e.preventDefault(); if (!desabilitado) setArrastando(true); }}
        onDragLeave={() => setArrastando(false)}
        onDrop={e => { e.preventDefault(); setArrastando(false); if (!desabilitado) pegar(e.dataTransfer.files?.[0]); }}
        disabled={desabilitado}
      >
        {arquivo ? (
          <>
            <i className="bi bi-file-earmark-pdf-fill esp-envio-pdf" />
            <span className="esp-envio-txt">
              <strong>{arquivo.name}</strong>
              <span>{fmtTamanho(arquivo.size)}{progresso === null ? ' · toque pra trocar' : ''}</span>
            </span>
          </>
        ) : (
          <>
            <i className="bi bi-cloud-arrow-up" />
            <span className="esp-envio-txt">
              <strong>Arraste o PDF aqui ou toque pra escolher</strong>
              <span>O quantitativo que você já fez no seu programa · até {MAX_PDF_MB} MB</span>
            </span>
          </>
        )}
        {progresso !== null && (
          <span className="esp-envio-barra" aria-label={`Enviando ${progresso}%`}><span style={{ width: `${progresso}%` }} /></span>
        )}
      </button>
      <input ref={input} type="file" accept="application/pdf,.pdf" hidden onChange={e => { pegar(e.target.files?.[0]); e.target.value = ''; }} />
      {erro && <div className="esp-erro mt-2"><i className="bi bi-exclamation-circle" />{erro}</div>}
    </div>
  );
}
